import { defineAsyncComponent } from 'vue';

export { default as UserAutoSuggest } from './components/UserAutoSuggest';
export { default as UserAccordion } from './components/UserAccordion';
export { default as UserDropdown } from './components/UserDropdown';
export { default as UserSelectList } from './components/UserSelectList';
export {
	UserAssignSelect,
	UserAssignSelectContainerSkeleton,
} from './components/UserAssignSelect';

// Re-export shared types from feature level
export type {
	UserAssignSelectAssigneesPayload,
	UserAssignSelectRole,
} from './types';
export { UserAssignSelectSize } from './constants';

export {
	UserAssignSelectInline,
	type UserAssignSelectInlineProps,
} from './components/UserAssignSelectInline';

export const userRegistrationMicroFrontends = {
	UserRegistration: defineAsyncComponent(
		() => import('./components/UserRegistration')
	),
};

export const userEventAssignMicroFrontends = {
	UserEventAssign: defineAsyncComponent(
		() => import('./components/UserEventAssign/UserEventAssign.vue')
	),
};
